import {
  Component,
  OnInit, ViewChild, ElementRef, AfterViewChecked
} from "@angular/core";
import { CommonService } from "../../services/common/common.service";
import { ChatbotService } from "../../services/chatbot/chatbot.service";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-chat-feature',
  templateUrl: './chat-feature.component.html',
  styleUrls: ['./chat-feature.component.css']
})
export class ChatFeatureComponent implements AfterViewChecked {
  @ViewChild('chatContent', { static: false }) chatContent!: ElementRef;
  ngAfterViewChecked(): void {
    if (!this.isUserScrolling) {
      this.scrollToBottom();
    }
  }
  isUserScrolling = false;
  clientID: any;
  user_id: any;
  soList: any;
  projectID: number | null = null;
  inputMessage: string = '';
  assistantID: string = '';
  chatMessages: Array<{ type: string, message: string, created_at:string }> = []; // Array to hold messages
  chatMessagesData: boolean = false;
  userAtBottom = true;
  payload: any;
  constructor(
    private CommonService: CommonService,
    private ChatbotService: ChatbotService,
    private sanitizer: DomSanitizer,
  ) { }
  ngOnInit() {
    this.clientID = localStorage.getItem("customerId");
    this.user_id = localStorage.getItem("user_id");
    const payload = {
      "modelName": "department",
      "whereCondition": {
        "client_id": this.clientID,
        "inactive": 1,
        "chat_enabled":1
      },
      "pagination": {
        "pageSize": 10000,
        "page": 1
      }
    }
    this.CommonService.getRecords(payload).subscribe(
      (e: any) => {
        // this.soList = e.data;
        
        this.soList = e.data.filter(
          (item: any) => item.chat_enabled === 1 && item.assistant_id !== null
        );
        console.log("this.soList: ", this.soList);
        // Auto-select the first project if the list is not empty
        if (this.soList.length > 0) {
          this.projectID = this.soList[0].id;
          this.assistantID = this.soList[0].assistant_id;
          this.getchatHistory(this.projectID);
        }
      }
    );
  }
  getchatHistory(projectID: any) {
    this.chatMessages = [];
    this.chatMessagesData = false;
    this.payload =
    {
      "modelName": "chat_details",
      "whereCondition": {
        "project_id": projectID
      },
      "orderBy": {
        "field": 'id',
        "order": 'ASC'
      },
      "pagination": {
        "pageSize": 1000000,
        "page": 1
      }
    }
    this.CommonService.getRecords(this.payload).subscribe((response: any) => {
      if (response.code == 1) {
        if (response.data.length > 0) {
          this.chatMessages = response.data;
          console.log("this.chatMessages -- ",this.chatMessages);
          this.chatMessagesData = true;
        }
      }
    });
  }
  scrollToBottom(): void {
    try {
      const element = this.chatContent.nativeElement;
      element.scrollTop = element.scrollHeight;
    } catch (err) {
      console.error('Scroll to bottom error:', err);
    }
  }
  onScroll(): void {
    const element = this.chatContent.nativeElement;
    const isAtBottom =
      element.scrollHeight - element.scrollTop === element.clientHeight;

    // Update the manual scrolling flag
    this.isUserScrolling = !isAtBottom;
  }
  selectProject(projectId: number,assistantId: string) {
    console.log("assistantId--",assistantId);
    this.projectID = projectId;
    this.assistantID = assistantId;
    this.getchatHistory(this.projectID);
  }
  submitmsg() {
    if (this.inputMessage.trim()) {
      console.log('Message submitted:', this.inputMessage);
      // Push the user message to the chatMessages array
      const currentDateTime = new Date().toISOString(); 
      this.chatMessages.push({ type: 'send', message: this.inputMessage, created_at: currentDateTime, });
      this.chatMessagesData = true;
      const payload = {
        user_id: this.user_id,
        client_id: this.clientID,
        project_id: this.projectID,
        message: this.inputMessage,
        assistant_id: this.assistantID
      }
      this.ChatbotService.chatwebhook(payload).subscribe(
        (e: any) => {
          console.log("response: ", e)
          // Received bot response here
          const botResponseDateTime = new Date().toISOString();
          const message = e.message;
          this.chatMessages.push({ type: 'receive', message: message, created_at: botResponseDateTime, });
          this.chatMessagesData = true;
        }
      );
      // Force scroll to bottom after submitting a message
      this.isUserScrolling = false;
      this.scrollToBottom();
      // Add your logic here, like sending the message to the server or displaying it in the chat
      this.inputMessage = ''; // Clear the input box after submitting
    } else {
      console.log('Input is empty');
    }
  }
  getParsedMessage(message: string): SafeHtml {
    if (!message) {
      return '';
    }
    // console.log("message before -- ", message);
    // Step 1: Replace Markdown-style links with anchor tags
    let formattedMessage = message.replace(
      /\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g,
      '<br/><a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );
    // Step 2: Replace \n with <br> for line breaks
    formattedMessage = formattedMessage.replace(/\n/g, '<br/>');
    // Step 3: Sanitize the final HTML content
    const msg = this.sanitizer.bypassSecurityTrustHtml(formattedMessage);
    // console.log("message after -- ", msg);
    return msg;
  }
  getFormattedDate(dateString: string): string {
    const date = new Date(dateString);
    const today = new Date();
  
    // Check if the date is today or yesterday
    const isToday = date.toDateString() === today.toDateString();
    const isYesterday = new Date(today.setDate(today.getDate() - 1)).toDateString() === date.toDateString();
  
    const timeOptions: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: true };
    const dateOptions: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' }; // For "26 Dec 2024"
  
    if (isToday) {
      return `${date.toLocaleTimeString([], timeOptions)} | Today`;
    } else if (isYesterday) {
      return `${date.toLocaleTimeString([], timeOptions)} | Yesterday`;
    } else {
      return `${date.toLocaleTimeString([], timeOptions)} | ${date.toLocaleDateString(undefined, dateOptions)}`;
    }
  }
}
